import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { queryClient } from '@api/queryClient';
import { Question } from 'types/question.types';
import {
  updateEventQuestionnaireQuestion,
  UpdateEventQuestionnaireQuestionResult
} from '@event-editor/api/questionnaire/updateEventQuestionnaireQuestion';
import { eventEditorQueryKeys } from '@event-editor/queryKeys';

interface UpdateQuestionVariables {
  eventId: number;
  question: Question;
}

export const useUpdateQuestionMutation = (
  onError: () => void,
  onSuccess?: () => void
): UseMutationResult<UpdateEventQuestionnaireQuestionResult, Error, UpdateQuestionVariables> => {
  return useMutation({
    mutationFn: (variables: UpdateQuestionVariables) =>
      updateEventQuestionnaireQuestion({
        eventId: variables.eventId,
        question: {
          id: variables.question.id,
          label: variables.question.label,
          type: variables.question.type,
          options: variables.question.options,
          hasOtherOption: variables.question.hasOtherOption,
          shownBefore: true,
          isRequired: variables.question.isRequired ?? false,
          properties: variables.question.properties,
          isDeleted: variables.question.isDeleted ?? false
        }
      }),
    onError,
    onSuccess: (result, variables) => {
      queryClient.invalidateQueries({
        queryKey: eventEditorQueryKeys.event(variables.eventId)
      });
      // TODO: Invalidate the guest queries here once they are implemented

      onSuccess?.();
    }
  });
};
